import Vue from 'vue';
import "@fortawesome/fontawesome-free/css/all.css";
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: "mdi" || "fa",
      },
});
